import React from 'react';
import { useRecordContext, DateField } from 'react-admin';
import { formatDistanceToNow, parseISO, format } from 'date-fns';
import { Tooltip, Box } from '@mui/material';
import { DATE_TIME_OPTIONS } from '../../../app/app.component';

const RetryInitiatedAtField = ({ source, label }) => {
    const record = useRecordContext();
    
    if (!record || !record[source]) {
        return (
            <Box>
                <strong>{label}:</strong> Never
            </Box>
        );
    }

    const retryDate = parseISO(record[source]);
    const relativeTime = formatDistanceToNow(retryDate, { addSuffix: true });
    const fullTimestamp = format(retryDate, 'PPpp'); // Full date and time

    return (
        <Box>
            <strong>{label}:</strong>{' '}
            <Tooltip title={fullTimestamp} arrow>
                <span style={{ textDecoration: 'underline dotted', cursor: 'help' }}>
                    {relativeTime}
                </span>
            </Tooltip>
        </Box>
    );
};

export default RetryInitiatedAtField;
